import { createSelector, createSlice, current } from "@reduxjs/toolkit";
import { set } from "date-fns";

export const accountingBillsSlice = createSlice({
    name: "accountingBill",
    initialState: {
        accountingBills: [],
        selectedBills: {},
        popupOpen: false,
        filterStatus: null,
    },
    reducers: {
        setAccountingBills: (state, action) => {
            state.accountingBills = action.payload;
        },
        clearSelectedBills: (state) => {
            state.selectedBills = {};
        },
        checkBill: (state, action) => {
            const checkedBill = action.payload;
            state.selectedBills[checkedBill.id] = checkedBill;
        },
        unCheckBill: (state, action) => {
            const unCheckedBill = action.payload;
            delete state.selectedBills[unCheckedBill.id];
        },
        checkAllBills: (state) => {
            state.accountingBills.forEach((bill) => {
                state.selectedBills[bill.id] = bill;
            });
        },
        unCheckAllBills: (state) => {
            state.selectedBills = {};
        },
        openPopup: (state) => {
            state.popupOpen = true;
        },
        closePopup: (state) => {
            state.popupOpen = false;
        },
        setFilterStatus: (state, action) => {
            state.filterStatus = action.payload;
        },
        removeBill: (state, action) => {
            const billToRemove = action.payload;
            state.accountingBills = state.accountingBills.filter(
                (b) => b.id != billToRemove.id,
            );
        },
    },
});

export const {
    checkBill,
    unCheckBill,
    openPopup,
    closePopup,
    clearSelectedBills,
    setAccountingBills,
    setFilterStatus,
    checkAllBills,
    unCheckAllBills,
    removeBill,
} = accountingBillsSlice.actions;

export const selectFilterStatus = (state) => state.accountingBill.filterStatus;
export const selectAccountingBills = (state) =>
    state.accountingBill.accountingBills;
export const selectBillIsChecked = (state, billId) =>
    state.accountingBill.selectedBills[billId] != undefined;
export const selectSelectedBills = (state) =>
    state.accountingBill.selectedBills;
export const selectPopupOpen = (state) => state.accountingBill.popupOpen;

export default accountingBillsSlice.reducer;
